// extracted by mini-css-extract-plugin
module.exports = {"specialistsRadio":"I2Gyw","specialistsRadio_radio-label":"CYIEl"};